import { TheNav, Fotter } from './Home'

const TermsAndConditions = () => {
  return (
    <section className="unid:mx-[100px] mx-[50px] undi:px-32 px-16  py-8 bg-white text-gray-800 undi:mt-14 mt-20">
      <h1 className="text-3xl font-bold mb-8 text-center font-times" style={{ color: '#D72427' }}>
        Conditions Générales d'Utilisation (CGU)
      </h1>
      
      <div className="mb-6">
        <p className="font-bold text-gray-900">La Francilienne de la Formation</p>
        <p>15 rue de l'Université, 93160 Noisy-le-Grand</p>
        <p>
          Email : <a href="mailto:Direction.francilienne.formation@gmail.com" className="hover:underline" style={{ color: '#D72427' }}>
            Direction.francilienne.formation@gmail.com
          </a>
        </p>
        <p>Téléphone : 09 52 30 99 38</p>
        <p>Siret : 89462489900015</p>
      </div>

      <div className="space-y-8">
        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>1. Objet</h2>
          <p>Les présentes Conditions Générales de Vente (CGV) régissent l'ensemble des prestations de formation proposées par La Francilienne de la Formation. Elles définissent les droits et obligations des parties dans le cadre des contrats de vente de prestations de formation.</p>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>2. Champ d'application</h2>
          <p>Les présentes CGV s'appliquent à toutes les offres de services et formations proposées par La Francilienne de la Formation. Toute commande de formation implique l'adhésion sans réserve aux présentes CGV par le client.</p>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>3. Offre de formation</h2>
          <ul className="space-y-4">
            <li>
              <p>Description des formations : La Francilienne de la Formation propose des formations pour adultes dans les domaines de la sécurité privée, de la sécurité incendie, et du sauvetage secourisme du travail. Les descriptifs détaillés des formations (objectifs, contenus, modalités, durée) sont disponibles sur demande.</p>
            </li>
            <li>
              <p>Modification de l'offre : La Francilienne de la Formation se réserve le droit de modifier le contenu des formations en fonction de l'évolution des réglementations ou des besoins spécifiques identifiés, après en avoir informé les clients.</p>
            </li>
          </ul>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>4. Tarifs et conditions de paiement</h2>
          <div className="space-y-4">
            <p>Tarifs : Les prix des formations sont indiqués en euros et sont exempts de TVA (TVA non applicable, article 293 B du CGI). Les tarifs incluent le coût de la formation, les supports pédagogiques et, le cas échéant, les frais de certification.</p>
            <p>Paiement : Le paiement des formations s'effectue par virement bancaire, chèque ou en espèces. Un acompte de 30% du montant total est demandé à l'inscription, le solde étant dû avant le début de la formation.</p>
            <p>Retard de paiement : En cas de retard de paiement, La Francilienne de la Formation se réserve le droit de suspendre l'accès à la formation jusqu'à régularisation de la situation.</p>
            <p>Révision des tarifs : La Francilienne de la Formation peut réviser ses tarifs à tout moment. Les nouvelles conditions tarifaires ne s'appliqueront qu'aux formations commandées après leur entrée en vigueur.</p>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>5. Modalités d'inscription</h2>
          <div className="space-y-4">
            <p>Inscription : L'inscription à une formation se fait via un formulaire d'inscription, disponible en ligne ou en version papier. L'inscription n'est considérée comme valide qu'après réception de l'acompte et de l'ensemble des documents requis.</p>
            <p>Confirmation : Une fois l'inscription validée, une confirmation écrite est envoyée au client, précisant les détails de la formation, les dates et les horaires.</p>
            <p>Annulation : En cas d'annulation par le client, celle-ci doit être notifiée par écrit. Selon la date de notification, les conditions suivantes s'appliquent :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Annulation à plus de 15 jours du début de la formation : remboursement intégral de l'acompte.</li>
              <li>Annulation entre 7 et 15 jours : remboursement de 50% de l'acompte.</li>
              <li>Annulation à moins de 7 jours : aucun remboursement de l'acompte.</li>
            </ul>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>6. Annulation et report de formation par le centre</h2>
          <div className="space-y-4">
            <p>Annulation par le centre : La Francilienne de la Formation se réserve le droit d'annuler ou de reporter une formation en cas de force majeure, de nombre insuffisant de participants ou pour tout autre motif légitime. Dans ce cas, les participants seront intégralement remboursés ou pourront choisir une autre session.</p>
            <p>Report : En cas de report, les participants seront informés au moins 5 jours ouvrables avant la date initialement prévue. Le report ne donne droit à aucun dédommagement.</p>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>7. Responsabilité</h2>
          <div className="space-y-4">
            <p>Obligation de moyens : La Francilienne de la Formation s'engage à fournir les formations avec le plus grand soin et selon les règles de l'art. Cependant, elle n'est tenue qu'à une obligation de moyens et non de résultat.</p>
            <p>Limitation de responsabilité : La Francilienne de la Formation ne saurait être tenue responsable des préjudices indirects, pertes de profit ou de données, subis par le client dans le cadre de l'exécution des formations.</p>
          </div>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>8. Propriété intellectuelle</h2>
          <p>Tous les supports de formation, contenus pédagogiques, documents et informations fournis dans le cadre des formations sont la propriété exclusive de La Francilienne de la Formation. Toute reproduction, diffusion ou utilisation non autorisée est interdite.</p>
        </article>

        <article className="border-b border-gray-200 pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>9. Confidentialité</h2>
          <p>La Francilienne de la Formation s'engage à respecter la confidentialité des informations communiquées par les clients dans le cadre de leur inscription et de la participation aux formations.</p>
        </article>

        <article className="pb-6">
          <h2 className="text-2xl font-semibold mb-4 font-times" style={{ color: '#D72427' }}>10. Droit applicable et juridiction compétente</h2>
          <p>Les présentes CGV sont régies par le droit français. Tout litige relatif à leur interprétation ou exécution sera de la compétence exclusive des tribunaux du ressort du siège social de La Francilienne de la Formation.</p>
        </article>
      </div>

      <footer className="mt-8 pt-6 border-t border-gray-200 text-sm text-gray-600">
        <p>Dernière mise à jour : 05/06/2023</p>
        <p>Gérant : Nadir SAIDI</p>
        <p>Ces Conditions Générales de Vente sont mises à disposition des clients lors de l'inscription et disponibles sur demande.</p>
      </footer>
    </section>
  );
};

export const ConditionsGeneralsUsers = () =>{
    return(
        <>
            <TheNav/>
            <TermsAndConditions />
            <Fotter/>
        </>
    );
}